import Vue from 'vue'
import App from './App.vue'
import router from './router'

Vue.prototype.backend = (process.env.NODE_ENV === 'production') ? 'https://wowenvios.tecnosoftesp.com/backend/api/' : 'http://localhost:80/wowenvios/backend/api/'
Vue.prototype.domain = (process.env.NODE_ENV === 'production') ? 'https://wowenvios.tecnosoftesp.com' : 'http://localhost:3000'


// Vue.prototype.applicationIdSquare = (process.env.NODE_ENV === 'production') ? 'sandbox-sq0idb-4ZKX-TT23PtW2zw-zoKzSw' : 'sandbox-sq0idb-4ZKX-TT23PtW2zw-zoKzSw'
Vue.prototype.applicationIdSquare = (process.env.NODE_ENV === 'production') ? 'sandbox-sq0idb-4ZKX-TT23PtW2zw-zoKzSw' : 'sandbox-sq0idb-4ZKX-TT23PtW2zw-zoKzSw'

// Vue.prototype.apiRedpack = (process.env.NODE_ENV === 'production') ? 'https://api.redpack.com.mx:5200/redpack/' : 'https://apiqa.redpack.com.mx:5200/redpack/'
Vue.prototype.apiRedpack = (process.env.NODE_ENV === 'production') ? 'https://apiqa.redpack.com.mx:5200/redpack/' : 'https://apiqa.redpack.com.mx:5200/redpack/'


// mercado pago
// Vue.prototype.publicKeyMP = (process.env.NODE_ENV === 'production') ? 'APP_USR-4bf06d46-a38e-4772-ad02-43f201882f72' : 'TEST-2a73b5f4-dba4-431f-8d08-e589e7d40721'
Vue.prototype.publicKeyMP = (process.env.NODE_ENV === 'production') ? 'TEST-2a73b5f4-dba4-431f-8d08-e589e7d40721' : 'TEST-2a73b5f4-dba4-431f-8d08-e589e7d40721'



Vue.config.productionTip = false

// global functions

Vue.prototype.dateFormat = function(date)
{
  let d = new Date(date)

  let month = (d.getMonth()+1).toString().padStart(2,'0')
  let day = d.getDate().toString().padStart(2,'0')
  let year = d.getFullYear()

  return day + '/' + month + '/' + year
}


Vue.prototype.datetimeFormat = function(datetime)
{
  let d = new Date(datetime)
  let months = Array('Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre');


  let month = months[d.getMonth()]
  let day = d.getDate().toString().padStart(2,'0')
  let year = d.getFullYear()


  let hour = null
  if(d.getHours() == 0)
    hour = '12'
  else if(d.getHours() > 12)
    hour = (d.getHours() - 12).toString().padStart(2,'0')
  else
    hour = d.getHours().toString().padStart(2,'0')

  let minute = d.getMinutes().toString().padStart(2,'0')
  let turno = d.getHours() >= 12 ? 'pm.' : 'am.'


  return day + ' de ' + month + ' del ' + year + ' ' + hour + ':' + minute + ' ' + turno
}


Vue.prototype.datetimeFormat2 = function(datetime)
{
  let d = new Date(datetime)
  
  let month = (d.getMonth()+1).toString().padStart(2,'0')
  let day = d.getDate().toString().padStart(2,'0')
  let year = d.getFullYear()


  let hour = null
  if(d.getHours() == 0)
    hour = '12'
  else if(d.getHours() > 12)
    hour = (d.getHours() - 12).toString().padStart(2,'0')
  else
    hour = d.getHours().toString().padStart(2,'0')

  let minute = d.getMinutes().toString().padStart(2,'0')
  let turno = d.getHours() >= 12 ? 'pm.' : 'am.'


  return day + '/' + month + '/' + year + ' ' + hour + ':' + minute + ' ' + turno
}


Vue.prototype.phoneFormat = function(p)
{
  if(p != null)
  {
    let newPhone = p[0]+p[1]+'-'+p[2]+p[3]+p[4]+p[5]+'-'+p[6]+p[7]+p[8]+p[9]
    return newPhone
  }
  else
    return null
} 


import vuetify from '@/plugins/vuetify'


new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
